/**
 * Pure helpers for operator delete-confirm (D-AV53-010 / Sonar complexity).
 */

export function parseCanonicalCustomerId(
  routeCustomerId: string | undefined,
  entityCustomerId: string | number | null | undefined,
): { ok: true; customerId: number; customerIdStr: string } | { ok: false; error: string } {
  if (!routeCustomerId?.trim()) {
    return { ok: false, error: "Customer is not available." };
  }
  const routeId = Number(routeCustomerId);
  if (!Number.isFinite(routeId)) {
    return { ok: false, error: "Customer id is invalid." };
  }
  const entityId = Number(entityCustomerId);
  if (!Number.isFinite(entityId)) {
    return { ok: false, error: "Customer id is invalid." };
  }
  if (routeId !== entityId) {
    return { ok: false, error: "Customer id mismatch. Refresh and try again." };
  }
  return { ok: true, customerId: routeId, customerIdStr: String(routeId) };
}
